// todo: set cookie in server
// import axios from 'axios';
import { StorageKey } from 'services/token';

import { FTUE_FLAG_TYPES, FtueFlags } from './types';

const CookieService = (function () {
  /**
   * set token cookie
   * @param value string to be added in cookie
   * @param timestamp in s
   */
  const setTokenCookie = (value: string, timestamp?: number) => {
    // todo: make a request to server and set the cookie
    let expired = '';
    if (timestamp) {
      const date = new Date(timestamp * 1000);
      expired = ` expires=${date.toUTCString()}`;
    }
    document.cookie = `${StorageKey.Token}=${value};${expired}`;
  };

  const unsetTokenCookie = () => {
    // todo: make a requst to server and unset the cookie
    setTokenCookie('', 1);
  };

  /**
   * set cookie
   * @param key key to be added in cookie
   * @param value value for key above to be added in cookie
   * @param duration in s
   */
  const set = (key: string, value: string, duration?: number) => {
    let maxAge = '';
    if (duration) {
      maxAge = ` max-age=${duration}`;
    }
    document.cookie = `${key}=${value};${maxAge}`;
  };

  const readFtueCookieValue = (): FtueFlags | undefined => {
    const KEY = 'ftue_flags';
    if (document.cookie.split(`${KEY}=`)[1]) {
      const stringValue = document.cookie.split(`${KEY}=`)[1].split(';')[0];
      return JSON.parse(stringValue);
    } else {
      return undefined;
    }
  };

  const isFirstTimeUser = (page_key: FTUE_FLAG_TYPES) => {
    const KEY = 'ftue_flags';
    const MAX_AGE = 34560000;
    const ftue_flags_default_value = JSON.stringify({
      gift_card_purchase_form:
        page_key === FTUE_FLAG_TYPES.GIFT_CARD_PURCHASE_FORM,
      company_admin_dashboard:
        page_key === FTUE_FLAG_TYPES.COMPANY_ADMIN_DASHBOARD
    });

    const value = CookieService.readFtueCookieValue();

    if (!value) {
      CookieService.set(KEY, ftue_flags_default_value, MAX_AGE);
      return true;
    } else {
      if (!value[page_key]) {
        CookieService.set(
          KEY,
          JSON.stringify({
            ...value,
            [page_key]: true
          }),
          MAX_AGE
        );
        return true;
      }
      CookieService.set(KEY, JSON.stringify(value), MAX_AGE);
      return false;
    }
  };

  return {
    setTokenCookie,
    unsetTokenCookie,
    isFirstTimeUser,
    readFtueCookieValue,
    set
  };
})();

export default CookieService;
